/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Base_No_ObservationsInputs */

const es_co2_error_base_no_observations = /** @type {(inputs: Error_Base_No_ObservationsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`No hay observaciones en borrador para enviar.`)
};

/**

* @param {Error_Base_No_ObservationsInputs} inputs
* @param {{ locale?: "es-CO" }} options
* @returns {LocalizedString}
*/
export const error_base_no_observations = /** @type {((inputs?: Error_Base_No_ObservationsInputs, options?: { locale?: "es-CO" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Base_No_ObservationsInputs, { locale?: "es-CO" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return es_co2_error_base_no_observations(inputs)
});